<template>
    <section class="section">
        <vue-headful
            title="TZ Design Box - Upload Price"
            description="TZ Design Box"
        />

        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'catalog-i18n'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <title-bar>
                Catalog Translation
                </title-bar>
                <div>
                    <b-field label="Source Language" grouped>
                        <b-select placeholder="Select a language" v-model="source">
                            <option v-for="o in possibleSources" :key="o [0]" :value="o [0]"
                            >{{ o [1] }}</option>
                        </b-select>
                    </b-field>
                    <b-field label="Target Language" grouped>
                        <b-select placeholder="Select a language" v-model="target">
                            <option v-for="o in possibleTargets" :key="o [0]" :value="o [0]"
                            >{{ o [1] }}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="tile is-ancestor">
                    <catalog-list-entry v-for="cat in catalogs" :key="cat.id"
                        :id="cat.id"
                        :image="cat.props.image"
                        :label="cat.props.label"
                        :name="cat.props.name"
                        :t9n_tags="cat.t9n_tags"
                    @catalog-select="catalogSelected"></catalog-list-entry>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TitleBar                 from '@/components/TitleBar'
import CatalogListEntry         from '@/components/catalog/CatalogListEntry'
import MenuVert                 from '@/components/MenuVert'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'CatalogListView',
    components: {
        TitleBar, CatalogListEntry, MenuVert
    },
    computed: {
        ...mapState   ("translation", {
            catalogs  : state => state.catalogs,
            sourceLang: state => state.sourceLang,
            targetLang: state => state.targetLang,
            }),
        ...mapGetters ("translation", ["possibleSources", "possibleTargets"]),
        source : {
            get () { return this.sourceLang},
            set (val) {
                this.$store.commit ("translation/changeSourceLang", val)
            }
        },
        target : {
            get () { return this.targetLang},
            set (val) {
                this.$store.commit ("translation/changeTargetLang", val)
            }
        }
    },
    methods: {
        catalogSelected (catId) {
            this.$router.push ({name: "catalog", params: {id: catId}})
        }
    },
    mounted () {
        this.$store.dispatch ("translation/loadCatalogs", {self: this})
    }
}
</script>

<style>

</style>